import { useTranslation } from "react-i18next";

const ConstructionBanner = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="bg-papayaText text-center text-white py-2 border-b-indigo-500 hidden">
      <p>{t("bannerText")}</p>
    </div>
  );
};

export default ConstructionBanner;
